import React from "react"
import { css } from "@emotion/react"
import { Theme } from "@myvp/shared/src/styles/theme"

const svgCss = (theme: Theme) => css`
  flex-shrink: 0;
  --fill: ${theme.palette.content.secondary.default};
`

const LogoV = () => (
  <svg
    css={svgCss}
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 0.5H3.46283L10.0559 13.5741L16.6015 0.5H20L10.0196 20.5L0 0.5Z"
      fill="var(--fill)"
    />
    <path
      d="M5.4975 0.533041L10.0056 9.40906L14.5081 0.533041C14.5081 0.533041 5.4975 0.522008 5.4975 0.533041Z"
      fill="var(--fill)"
    />
  </svg>
)

export default LogoV
